export type RoutePresentation = 'page' | 'overlay' | 'fullPage';

/**
 * Internal helper for resolving a route's presentation mode.
 *
 * Keeping this logic centralized avoids subtle inconsistencies across breadcrumbs/header/layout/portals.
 */
export function resolveRoutePresentation(staticData?: { presentation?: RoutePresentation }): RoutePresentation {
    return staticData?.presentation ?? 'page';
}

export function isOverlayRoute(staticData?: { presentation?: RoutePresentation }): boolean {
    return resolveRoutePresentation(staticData) === 'overlay';
}

export function isFullPageRoute(staticData?: { presentation?: RoutePresentation }): boolean {
    return resolveRoutePresentation(staticData) === 'fullPage';
}
